// material-ui
import { alpha } from '@mui/material/styles';
import { textAlign } from '@mui/system';

// project import
import getColors from '../../utils/getColors';
import getShadow from '../../utils/getShadow';

function getColorStyle({ variant, color, theme }) {
  const colors = getColors(theme, color);
  const { lighter, main, dark, darker, contrastText } = colors;

  const buttonShadow = `${color}Button`;
  const shadows = getShadow(theme, buttonShadow);

  const commonShadow = {
    '&::after': {
      boxShadow: `0 0 5px 5px ${alpha(main, 0.9)}`
    },
    '&:active::after': {
      boxShadow: `0 0 0 0 ${alpha(main, 0.9)}`
    },
    '&:focus-visible': {
      outline: `2px solid ${dark}`,
      outlineOffset: 2
    }
  };

  switch (variant) {
    case 'contained':
      return {
        '&:hover': {
          backgroundColor: dark
        },
        ...commonShadow
      };
    case 'shadow':
      return {
        color: contrastText,
        backgroundColor: main,
        boxShadow: shadows,
        '&:hover': {
          boxShadow: 'none',
          backgroundColor: dark
        },
        ...commonShadow
      };
    case 'outlined':
      return {
        borderColor: main,
        '&:hover': {
          color: dark,
          backgroundColor: 'transparent',
          borderColor: dark
        },
        ...commonShadow
      };
    case 'dashed':
      return {
        color: main,
        borderColor: main,
        backgroundColor: lighter,
        '&:hover': {
          color: dark,
          borderColor: dark
        },
        ...commonShadow
      };
    case 'text':
    default:
      return {
        color: dark,
        '&:hover': {
          color: darker,
          backgroundColor: lighter
        },
        ...commonShadow
      };
  }
}

// ==============================|| OVERRIDES - BUTTON ||============================== //

export default function DataGrid(theme) {
  const primaryDashed = getColorStyle({ variant: 'dashed', color: 'primary', theme });
  const primaryShadow = getColorStyle({ variant: 'shadow', color: 'primary', theme });

  const disabledStyle = {
    '&.Mui-disabled': {
      backgroundColor: theme.palette.grey[200]
    }
  };
  const iconStyle = {
    '&>*:nth-of-type(1)': {
      fontSize: 'inherit'
    }
  };

  return {
    MuiDataGrid: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {
        root: {
          //border: '1px solid #e0e0e0',
          borderRadius: '0',
          marginLeft: '-20px',
          marginRight: '-20px',
          marginBottom: '-20px',
        },
        columnHeaders: {
          backgroundColor: '#f5f5f5',
          color: '#333',
          fontWeight: 'bold',
        },
        columnSeparator: {
          color: "#e0e0e0"
        },
        row: {
          borderTop: '1px solid #e0e0e0'
        },
        cell: {
          color: '#444',
          fontSize: '0.875rem',
          padding: '5px',
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center'
        },
        footerContainer: {
          backgroundColor: '#fafafa',
          borderTop: '1px solid #e0e0e0',
        },
      },
    }
  };
}
